"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uploadImage = uploadImage;
async function uploadImage(imageRepo, file) {
    return await imageRepo.uploadImage(file);
}
